import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

const TradeDeskLinkedIn = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>WiC x Trade Desk: LinkedIn Launchpad for Tech Internships: Get Seen, Get Hired!</h2>
                    <p class="site-post-meta">April 16, 2025</p>
                    <hr></hr>
                </section>
                <section>
                    <p>Hi WiC Members!

                    <br></br>
                    <br></br>

                    We had a fantastic event last week with The Trade Desk, LinkedIn Launchpad for Tech Internships: Get Seen, Get Hired! We were thrilled to hear directly from Rachel, a recruiter at The Trade Desk, about her experience reviewing applications and LinkedIn profiles. Rachel was incredibly kind and generously shared the slides from the event to help you enhance your LinkedIn profile. You can access the slides here: https://ttdcorp-my.sharepoint.com/:b:/g/personal/rachel_levine_thetradedesk_com/IQBd3JWaXj09QbPTv0D6ruosAaAKPYuTA4cQDUHU_1puMts?e=b3bb4C.

                    <br></br>
                    <br></br>


                    Rachel is also open to anyone interested in recruitment for our Summer 2027 internships. If you’re eligible (you must graduate between December 2027 and June 2028), please don’t hesitate to reach out to her at rachel.levine@thetradedesk.com.
                    
                    
                    <br></br>
                    <br></br>
                    
                    
                    We're so grateful to Rachel for speaking with us and offering such thoughtful advice. It was a great opportunity to ask one-on-one questions, gain special tips, and imagine what a future in tech could look like at Trade Desk. We hope everyone enjoyed the pizza and drinks!
                    
                    
                    </p>
                    
                </section>
                
            </div>
        </div>      
      </div>
    </div>
  );
};

export default TradeDeskLinkedIn;
